import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { CookiesService } from '../../services/cookies/cookies.service';
import { includes, some } from 'lodash-es';
import { AuthService } from '../../services/auth/auth.service';
import { NS_Enums } from 'src/app/static/namespace';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private authService: AuthService = inject(AuthService);
  private cacheService: CookiesService = inject(CookiesService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let skipToken = false;
    try{
      skipToken = request.headers.get('skip') === 'true';
    }catch(error){
      console.error('Error processing headers:', error);
    }
    return this.authService.isTokenExpired().pipe(
      switchMap(expired => {
        if (expired && !skipToken) {
          // Token is expired, get a new one
          return this.authService.refreshToken().pipe(
            switchMap((newToken) => {
              return this.processRequest(request, next, newToken)
            })
          );
        } else {
          // Token is valid, proceed with the original request
          return this.processRequest(request, next);
        }
      }),
      catchError(error => {
        // Handle any errors here, possibly logging or user notification
        return throwError(error);
      })
    );
  }

  private processRequest(request: HttpRequest<any>, next: HttpHandler, newToken?: string): Observable<HttpEvent<any>> {
    let skipToken = false;

    try {
      skipToken = request.headers.get('skip') === 'true';
      request = request.clone({ headers: request.headers.delete('skip') });
    } catch (error) {
      console.error('Error processing headers:', error);
      // Handle the error appropriately
    }

    if (!skipToken && this.shouldAddToken(request)) {
      const jwtToken = newToken || this.getJwtToken();
      if(jwtToken){
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${jwtToken}`
          }
        });
      }
    }

    return next.handle(request);
  }


  getJwtToken(): string{
    return this.cacheService.getObject(NS_Enums.cacheKeysEnum.saras_auth_key)
  }

  shouldAddToken(request: HttpRequest<any>): boolean{
    // Check if the 'skip' header is present and set to 'true'
    return !some(this.noTokenFor, url => includes(request.url, url));
  }

  private noTokenFor = ['/forgot', '/password', '/resend-email', '/verify-firebase-token'];
  
}
